import { useRouter } from 'next/router';
import {
  getPathWithoutQueryParams,
  parsePathAndRemoveParams,
} from '@/utils/helpers';

export function useUrlAndHashFromPath(excludedParams: string[] = []) {
  const { asPath } = useRouter();
  const { url, hash, clearUrl, queryString, restQueryString } =
    parsePathAndRemoveParams(asPath, excludedParams);
  const trimmedUrl = getPathWithoutQueryParams(asPath, excludedParams);

  return {
    url,
    hash,
    clearUrl,
    queryString,
    restQueryString,
    trimmedUrl,
  };
}
